module.exports = __webpack_public_path__ + "img/pro_capture8.2dc99f38.png";